import { Alert, Grid, } from '@mantine/core'



import React, { useEffect, useState } from 'react';
import { SecurityRow } from '../../components/security_row';
import { UseFormReturnType } from '@mantine/form';
import { CustomAutocomplete, FirebaseTransaction, TransactionInvestmentType, Security, SecurityItem, PortfolioPositionWithCustodianAccountsRow } from '../../types';



export interface SecurityFormProps {

    form: UseFormReturnType<FirebaseTransaction>,
    securitiesList: Security[],
    disabled: boolean,

}


const SecurityForm = ({ form, securitiesList, disabled }: SecurityFormProps) => {

    const [addedSecuritiesList, setAddedSecuritiesList] = useState<SecurityItem[]>([{ quantity: 1 }])

    const [displayedSecuritiesList, setDisplayedSecuritiesList] = useState<(Security & CustomAutocomplete)[] | (TransactionInvestmentType & CustomAutocomplete)[]>([])


    useEffect(() => {

        if (disabled) {
            setDisplayedSecuritiesList(form.values.securities.map((security) => {
                return security.value as any;
            }));
        }

        else {


            if (form.values.transactionType === "security_out") {


                let securitiesRows: (TransactionInvestmentType | undefined)[] = form.values.position?.filter((position: PortfolioPositionWithCustodianAccountsRow) => position._INVESTMENT_INVESTMENTTYPE_CODE_ === "CS" && form.values.custodianAccount?.id === position.CUSTODIANACCOUNT).map((position: PortfolioPositionWithCustodianAccountsRow) => {

                    if (!position.TICKER || !position.EXCHANGE_CODE || !position.EXCHANGE_DESCRIPTION || !position.ISSUE_COUNTRY_CODE) {
                        return;
                    }
                    let data: TransactionInvestmentType & CustomAutocomplete = {
                        ...position, label: position.TICKER + " - " + position.EXCHANGE_DESCRIPTION + " - (" + position.QTYEND + ")",
                        value: position.CODE,
                        _UDF_ISLAMIC_OR_NOT_: position._UDF_ISLAMIC_OR_NOT_!,
                        _ISSUER_NAMESORT_: position._KEY_,
                        TICKER: position.TICKER!,
                        EXCHANGE_CODE: position.EXCHANGE_CODE!,
                        EXCHANGE_DESCRIPTION: position.EXCHANGE_DESCRIPTION!,
                    };
                    data["id"] = position.CODE;
                    data["text_r"] = position.TICKER + " - " + position.EXCHANGE_DESCRIPTION + " - (" + position.QTYEND + ")";
                    data["text_l"] = position.CODE;
                    data["group"] = data.EXCHANGE_DESCRIPTION!;
                    data["key"] = position.CODE;
                    // data["value"] = position.CODE;

                    return data;
                }) || [];

                securitiesRows = securitiesRows.filter((validSecurity) => !!validSecurity);
                setDisplayedSecuritiesList(securitiesRows as any);  //TODO: remove any and fix this later

            }
            else {
                setDisplayedSecuritiesList(securitiesList as any);
            }

        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [form.values.position, form.values.custodianAccount?.id])

    // const handleQuantityComapny = (value: any, idx: number) => {

    //     const currentCompanies = [...addedSecuritiesList];
    //     const chosenCompanyPrice = securitiesList.filter((company: any) => company.value == currentCompanies[idx].value)[0].price
    //     currentCompanies[idx] = { ...currentCompanies[idx], quantity: value, price: chosenCompanyPrice * value };
    //     setAddedSecuritiesList(currentCompanies)
    //     form.setFieldValue("securities", currentCompanies);

    // }

    if (!displayedSecuritiesList.length)
        if (!form.values.customerID)
            return <Grid.Col span={{ xs: 12 }} >

                <Alert
                    style={{ width: "100%" }}
                >
                    Please Select a portfolio
                </Alert>
            </Grid.Col>

        else return <Grid.Col span={{ xs: 12 }} >
            <Alert
                style={{ width: "100%" }}
            >
                No securities found
            </Alert>
        </Grid.Col >
    return (

        <>
            {/* <Grid.Col span={{ xs: 12 }}>

                <Radio.Group
                    label="Action"
                    required
                    description="action of Security flow update"

                    {...form.getInputProps('action')}
                >
                    <Radio mt="xs" value="ReceiveLong" label="Security In" />
                    <Radio mt="xs" value="DeliverLong" label="Security Out" />

                </Radio.Group>
            </Grid.Col> */}

            {addedSecuritiesList?.map((security: any, idx: number) => {

                return <SecurityRow
                    disabled={disabled}
                    securitiesList={displayedSecuritiesList}
                    addedSecuritiesList={addedSecuritiesList}
                    setAddedSecuritiesList={setAddedSecuritiesList}
                    form={form}
                    idx={idx}
                    key={idx}
                />
            })



            }

        </>


    )
}

export default SecurityForm
